import React, {useEffect, useState} from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const getHoraAtual = () => {
    return new Date().getHours().toString().padStart(2,'0')+':'+
        new Date().getMinutes().toString().padStart(2,'0')+':'+
        new Date().getSeconds().toString().padStart(2,'0');
}

const HoraLabel = (props) => {

    const [hora,setHora] = useState(getHoraAtual);

    useEffect(()=>{
        //  getPage()
        const interval=setInterval(()=>{
            setHora(getHoraAtual());
        },1000);
        return()=>clearInterval(interval)
    },[hora])


        return (<React.Fragment>
                <Grid container item  style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-end', justifyContent: 'flex-end', alignContent: 'flex-end'}}>
                    <Typography variant="h2">{hora.substr(0,5)}</Typography><Typography variant="h4">{hora.substr(5,3)}</Typography>
                </Grid>
            </React.Fragment>

        )
    }

export default HoraLabel;


